import Vue from 'vue';

import RoCopy from './RoCopy';

Vue.component('RoCopy', RoCopy);

export default { RoCopy };



// WEBPACK FOOTER //
// ./scripts/ro-copy/index.js